import React from "react";
import * as api from "../../../api/generated-api";

export default function CheckIcon({ signingStatus }) {
  return (
    <React.Fragment>
      {signingStatus === api.SigningStatus.signed && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 11.5L9 13.5L13.5 9M15 19H5C3.89543 19 3 18.1046 3 17V3C3 1.89543 3.89543 1 5 1H12.1716C12.702 1 13.2107 1.21071 13.5858 1.58579L16.4142 4.41421C16.7893 4.78929 17 5.29799 17 5.82843V17C17 18.1046 16.1046 19 15 19Z"
            stroke="#35C379"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}
      {signingStatus === api.SigningStatus.requested && (
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1716 2C10.4368 2 10.6911 2.10536 10.8787 2.29289L13.7071 5.12132C13.8946 5.30886 14 5.56321 14 5.82843V17C14 17.5523 13.5523 18 13 18H3C2.44771 18 2 17.5523 2 17V3C2 2.44772 2.44771 2 3 2H10.1716ZM12.2929 0.878679C11.7303 0.31607 10.9672 0 10.1716 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H13C14.6569 20 16 18.6569 16 17V5.82843C16 5.03278 15.6839 4.26972 15.1213 3.70711L12.2929 0.878679Z"
            fill="#222222"
          />
        </svg>
      )}
      {!signingStatus ||
        (signingStatus === api.SigningStatus.notRequested && (
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1716 2C10.4368 2 10.6911 2.10536 10.8787 2.29289L13.7071 5.12132C13.8946 5.30886 14 5.56321 14 5.82843V17C14 17.5523 13.5523 18 13 18H3C2.44771 18 2 17.5523 2 17V3C2 2.44772 2.44771 2 3 2H10.1716ZM12.2929 0.878679C11.7303 0.31607 10.9672 0 10.1716 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H13C14.6569 20 16 18.6569 16 17V5.82843C16 5.03278 15.6839 4.26972 15.1213 3.70711L12.2929 0.878679Z"
              fill="grey"
            />
          </svg>
        ))}
    </React.Fragment>
  );
}
